/* eslint-disable no-case-declarations */
import { BidsActionTypes, BidsActionUnion } from './actions';
import { Deal } from '../../types/deal.types';
import { BidsState } from './state';

export const initialBidsState: BidsState = {
  bids: [],
  compare: {
    compareMode: false,
    compareColumn: 'Spread',
    comparedBids: []
  },
  loading: false,
  loaded: false,
  error: undefined
};

export function bidsReducer(
  state: BidsState = initialBidsState,
  action: BidsActionUnion
): BidsState {
  switch (action.type) {
    case BidsActionTypes.LoadBids:
      return {
        ...state,
        loading: true,
        error: undefined
      };

    case BidsActionTypes.LoadBidsSuccess:
      const { data } = action.payload;

      return {
        ...state,
        bids: data,
        loading: false,
        loaded: true,
        error: undefined
      };

    case BidsActionTypes.LoadBidsFail:
      return {
        ...state,
        bids: [],
        loading: false,
        loaded: false,
        error: action.payload
      };

    case BidsActionTypes.CompareBidsModeChange:
      return {
        ...state,
        compare: {
          ...state.compare,
          compareMode: !state.compare.compareMode,
          compareColumn: !state.compare.compareMode
            ? initialBidsState.compare.compareColumn
            : state.compare.compareColumn,
          comparedBids: !state.compare.compareMode
            ? []
            : state.compare.comparedBids
        }
      };
    case BidsActionTypes.CompareBidsColumnChange:
      return {
        ...state,
        compare: {
          ...state.compare,
          compareColumn: action.payload
        }
      };
    case BidsActionTypes.CompareBidsListChange:
      const bidsIndex = state.compare.comparedBids.indexOf(action.payload);
      const update: number[] =
        bidsIndex === -1
          ? state.compare.comparedBids.concat(action.payload)
          : state.compare.comparedBids
              .slice(0, bidsIndex)
              .concat(state.compare.comparedBids.slice(bidsIndex + 1));
      return {
        ...state,
        compare: {
          ...state.compare,
          comparedBids: update
        }
      };
    case BidsActionTypes.CompareBidsReset:
      return { ...state, compare: { ...initialBidsState.compare } };

    default:
      return state;
  }
}

export const getBids = (state: BidsState): Deal[] => state.bids;

export const selectBidsLoaded = (state: BidsState) => state.loaded;
export const selectBidsLoading = (state: BidsState) => state.loading;

export const selectBidsError = (state: BidsState) => state.error;

export const selectBidsCompareMode = (state: BidsState): boolean =>
  state.compare.compareMode;
export const selectBidsCompareList = (state: BidsState): number[] =>
  state.compare.comparedBids;
export const selectBidsCompareColumn = (state: BidsState): string =>
  state.compare.compareColumn;
